// PartModal.js

import React from 'react';
import { Modal, Select, Input, Button } from 'antd';

const { Option } = Select;

const PartModal = ({ Form, form, visible, onFinish, onCancel, partData, status }) => {
    
     
    return (
        <Modal
            title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800' }}>Part</span>}

            // title="Part"
            visible={visible}
            onCancel={onCancel}
            footer={null}

        >
            <Form form={form} onFinish={onFinish} >
                <Form.Item name="PartType" label="Part Type">
                    <Select
                        style={{ width: '300px', marginLeft: '70px' }}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        disabled={status === 'Reviewed-Approved' || status === 'Closed-WNC' || status === 'Cmpl Pending Review'}
                    >
                        <Option value="New">New</Option>
                        <Option value="RTO">RTO</Option>
                        <Option value="UTEX">UTEX</Option>
                        <Option value="R&R">R&R</Option>

                    </Select>
                </Form.Item>

                <Form.Item name="PartNbr" label="Part Number">
                    <Input
                        style={{ width: '300px', marginLeft: '48px' }}

                        placeholder="Enter a Part Type"
                        disabled={status === 'Reviewed-Approved' || status === 'Closed-WNC' || status === 'Cmpl Pending Review'}
                    />
                </Form.Item>

                <Form.Item name="PartSerialNbr" label="Part Serial Number">
                    <Input
                    style={{ width: '300px', marginLeft: '4px' }}
                        placeholder="Enter a Part Serial"
                        disabled={status === 'Reviewed-Approved' || status === 'Closed-WNC' || status === 'Cmpl Pending Review'}
                    />
                </Form.Item>
                 


                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button htmlType="submit" style={{ background: '#2863ad', color: 'white' }}>
                        Save
                    </Button>
                    <Button key="cancel" onClick={onCancel} style={{ marginLeft: '10px' }}>
                        Cancel
                    </Button>
                </div>
            </Form>
        </Modal>

    );
};

export default PartModal;
